import { SCREEN } from "../useConsensusActivity";
import { shouldSuppressSoloTransition } from "../soloTransition";
import { EVENT_TYPES } from "./index";

const TIMEOUT_DURATION = 750;

export const studentRejoinHandler = ({
  event,
  clearTimeout,
  surveyTimeoutRef,
  setIsShowTransitionView,
  handleStateChange,
  hasSurvey = false,
  setAnnouncePhase = () => {},
}) => {
  const { event_type, data, event_id } = event ?? {}
  const { state, screen } = data ?? {}

  if (event_type === EVENT_TYPES.STUDENT_REJOIN) {
    // The rejoin screen is the observer's last cached screen, which is
    // `color_screen` for `challenge`. Apply the same Solo Time suppression as
    // the live path so a student reconnecting mid-question rejoins onto the
    // question rather than a blue screen.
    const suppressSoloTransition = shouldSuppressSoloTransition({
      state: state?.state,
      previousState: state?.previous_state,
      hasSurvey,
    });

    if (suppressSoloTransition) {
      if (surveyTimeoutRef.current) {
        clearTimeout(surveyTimeoutRef.current);
      }
      setIsShowTransitionView(false);
      // Keep screen-reader parity with the live path: no visible overlay, but
      // the phase change is still announced.
      setAnnouncePhase(true);
    } else {
      setAnnouncePhase(false);
      if (screen === SCREEN.COLOR) {
        if (surveyTimeoutRef.current) {
          clearTimeout(surveyTimeoutRef.current);
        }
        setIsShowTransitionView(true);
      }

      if (screen === SCREEN.CHALLENGE) {
        setTimeout(() => {
          setIsShowTransitionView(false);
        }, TIMEOUT_DURATION);
      }
    }

    handleStateChange(state, event_id, false);
  }
}
